import React, { useContext, useEffect, useMemo, useState } from 'react';
import { EscolaContext } from '../../contexts/escola';
import { belemApi } from '../../services/belemApi';

export default function Agendar() {
  const { alunoC, nasc, maeAluno, CPFAluno, AgendaAtendimento, aluno } = useContext(EscolaContext);

  const [dias, setDias] = useState([]);
  const [hora, setHora] = useState([]);
  const [selectedDia, setSelectedDia] = useState('');
  const [selectedAttId, setSelectedAttId] = useState('');

  const cdata1 = useMemo(() => String(selectedDia).split('/').join('-'), [selectedDia]);

  useEffect(() => {
    const loadDatas = async () => {
      try {
        const response = await belemApi.datasDisponiveis();
        setDias(response.data || []);
      } catch (err) {
        console.error('Erro ao buscar datas:', err);
        setDias([]);
      }
    };
    loadDatas();
  }, []);

  useEffect(() => {
    const loadHoras = async () => {
      if (!selectedDia) {
        setHora([]);
        return;
      }
      try {
        const response = await belemApi.horasDisponiveis(cdata1);
        setHora(response.data || []);
      } catch (err) {
        console.error('Erro ao buscar horários:', err);
        setHora([]);
      }
    };
    loadHoras();
  }, [selectedDia, cdata1]);

  const agendarAluno = () => {
    const alunoAgend = aluno?.[0]?.BEN_ALUNO;
    AgendaAtendimento(selectedAttId, maeAluno, nasc, CPFAluno, cdata1, alunoAgend);
  };

  return (
    <div className="flex flex-col md:py-3 px-4 h-screen ls:h-auto">
      <div className="flex-col flex items-center justify-center">
        <div className="text-xl font-semibold text-center font-abc text-letras2">
          <p>O atendimento é PRESENCIAL, selecione o dia e hora para comparecimento ao Posto de Atendimento.</p>
        </div>

        <div className="bg-white p-1 sm:max-w-md w-full">
          <div className="p-4">
            <div>
              <label className="font-abc font-bold uppercase text-letras2">Nome do Aluno</label>
              <input
                type="text"
                className="focus:outline-none uppercase border-b w-full rounded-t-lg px-4 p-4 border-letras2 font-abc bg-card/[.25] h-9"
                value={alunoC}
                readOnly
              />
            </div>
            <div>
              <label className="font-abc font-bold uppercase text-letras2">Nome da Mãe</label>
              <input
                type="text"
                className="focus:outline-none border-b w-full uppercase rounded-t-lg px-4 p-4 border-letras2 font-abc bg-card/[.25] h-9"
                value={maeAluno}
                readOnly
              />
            </div>
            <div>
              <label className="font-abc font-bold uppercase text-letras2">CPF</label>
              <input
                type="text"
                className="focus:outline-none border-b w-full rounded-t-lg px-4 p-4 border-letras2 font-abc bg-card/[.25] h-9"
                value={CPFAluno}
                readOnly
              />
            </div>
          </div>

          <div className="text-center ml-4">
            <select
              className="h-9 font-abc bg-base-Card/[.25] bg-gray-50 border border-letras text-sm rounded-lg focus:ring-letras focus:border-letras block w-[15rem] p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-letras"
              name="dia"
              id="dia"
              value={selectedDia}
              onChange={(e) => {
                setSelectedDia(e.target.value);
                setSelectedAttId('');
              }}
            >
              <option value="">Selecione o dia</option>
              {dias.map((dia) => (
                <option key={dia.DATA} value={dia.DATA}>
                  {dia.DATA}
                </option>
              ))}
            </select>
          </div>

          <div className="text-start p-2 font-abc ml-4">
            {hora.length === 0 && selectedDia && (
              <p className="text-sm text-red-600">Nenhum horário disponível para a data selecionada.</p>
            )}

            {hora.map((h) => (
              <label key={h.ATT_ID} className="block">
                <input
                  className="mr-2"
                  type="radio"
                  name="attId"
                  value={h.ATT_ID}
                  checked={selectedAttId === h.ATT_ID}
                  onChange={() => setSelectedAttId(h.ATT_ID)}
                />
                {h.HORA}
              </label>
            ))}
          </div>

          <div className="flex justify-center">
            <button
              className="rounded-full p-1 w-full sm:w-56 bg-green hover:bg-letras2 hover:text-2 cursor-pointer text-white text-lg font-semibold"
              onClick={agendarAluno}
            >
              AGENDAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
